/* ═══════════════════════════════════════
   MELT ARTISAN CHOCOLATES — Theme JS
═══════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {

  /* ── SCROLL REVEAL ── */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal,.reveal-l,.reveal-r').forEach(function (el) { revealObs.observe(el); });

  /* ── COUNTER ANIMATION ── */
  function countUp(el, target) {
    var v = 0, step = target / 80;
    var t = setInterval(function () {
      v += step;
      if (v >= target) { v = target; clearInterval(t); }
      el.textContent = Math.floor(v).toLocaleString('en-IN') + (target >= 10 ? '+' : '');
    }, 16);
  }
  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.querySelectorAll('[data-count]').forEach(function (el) { countUp(el, parseInt(el.dataset.count)); });
        countObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.hero-stats,.story-stats').forEach(function (el) { countObs.observe(el); });

  /* ── MOBILE MENU ── */
  var hamburger  = document.getElementById('meltHamburger');
  var mobileMenu = document.getElementById('meltMobileMenu');
  function closeMobileMenu() {
    if (hamburger) hamburger.classList.remove('open');
    if (mobileMenu) mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });
  if (mobileMenu) mobileMenu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMobileMenu); });

  /* ── HERO CAROUSEL ── */
  var heroIndex = 0;
  var heroSlides = document.querySelectorAll('.hero-slide');
  var heroDots   = document.querySelectorAll('.hero-dot');
  var heroTotal  = heroSlides.length;
  var heroAutoT;
  function heroGoTo(n) {
    heroIndex = (n + heroTotal) % heroTotal;
    heroSlides.forEach(function (s, i) { s.classList.toggle('active', i === heroIndex); });
    heroDots.forEach(function (d, i)   { d.classList.toggle('active', i === heroIndex); });
  }
  window.heroGoTo  = heroGoTo;
  window.heroSlide = function (dir) { heroGoTo(heroIndex + dir); clearInterval(heroAutoT); heroAutoT = setInterval(function () { heroGoTo(heroIndex + 1); }, 5000); };
  if (heroTotal > 0) heroAutoT = setInterval(function () { heroGoTo(heroIndex + 1); }, 5000);

  /* ── HERO VIDEO ── */
  window.loadVideo = function (ytId) {
    if (!ytId) return;
    var panel = document.getElementById('meltVideoPanel');
    var thumb = document.getElementById('meltVideoThumb');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.allowFullscreen = true;
    if (panel) panel.appendChild(iframe);
    if (thumb) thumb.style.display = 'none';
  };

  /* ── TOAST ── */
  function showToast(msg) {
    var toast = document.getElementById('meltToast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 4000);
  }
  window.showToast = showToast;

  /* ── CART DRAWER ── */
  var cartDrawer  = document.getElementById('meltCartDrawer');
  var cartOverlay = document.getElementById('meltCartOverlay');
  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }
  function renderCart(cart) {
    var itemsEl = document.getElementById('meltCartItems');
    var totalEl = document.getElementById('meltCartTotal');
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    if (!itemsEl) return;
    if (cart.item_count === 0) { itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty 🍫</div>'; if (totalEl) totalEl.textContent = ''; return; }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-item"><img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div class="cart-item-info"><div class="cart-item-name">' + item.product_title + '</div>' +
        '<div class="cart-item-price">₹' + (item.price / 100).toFixed(0) + '</div>' +
        '<div class="cart-item-qty"><button class="qty-btn" onclick="updateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
        '<span class="qty-val">' + item.quantity + '</span>' +
        '<button class="qty-btn" onclick="updateQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
        '</div></div></div>';
    });
    itemsEl.innerHTML = html;
    if (totalEl) totalEl.textContent = '₹' + (cart.total_price / 100).toFixed(0);
  }
  window.updateQty = function (key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  };
  window.openCart = function () {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  };
  window.closeCart = function () {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  if (cartOverlay) cartOverlay.addEventListener('click', window.closeCart);

  /* ── ADD TO CART ── */
  window.addToCart = function (variantId, qty) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); })
      .then(function () { window.openCart(); showToast('Added to cart! 🍫'); })
      .catch(function () { showToast('Something went wrong.'); });
  };

  /* ── WHATSAPP FORM ── */
  window.submitMeltForm = function (waNum) {
    var name  = (document.getElementById('meltFname')  || {value:''}).value.trim();
    var phone = (document.getElementById('meltFphone') || {value:''}).value.trim();
    if (!name || !phone) { alert('Please enter your name and phone number.'); return; }
    var occ = (document.getElementById('meltFoccasion') || {value:''}).value;
    var qty = (document.getElementById('meltFqty')      || {value:''}).value.trim();
    var bud = (document.getElementById('meltFbudget')   || {value:''}).value;
    var msg = (document.getElementById('meltFmsg')      || {value:''}).value.trim();
    var txt = encodeURIComponent('Hi! Custom order.\n\nName: ' + name + '\nPhone: ' + phone + '\n' + (occ?'Occasion: '+occ+'\n':'') + (qty?'Qty: '+qty+'\n':'') + (bud?'Budget: '+bud+'\n':'') + (msg?'Details: '+msg:''));
    window.open('https://wa.me/' + waNum + '?text=' + txt, '_blank');
    showToast('✓ Opening WhatsApp...');
  };

  /* ── NAV SCROLL ── */
  window.addEventListener('scroll', function () {
    var h = document.querySelector('.site-header');
    if (h) h.classList.toggle('scrolled', window.scrollY > 60);
  });

  /* ── INITIAL CART COUNT ── */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
  });

});
